import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";

import { Tooltip } from "@mui/material";

const AppraisalStatusIcon = ({
    status,
    section = null,
    isAppraiser = false,
}) => {
    const title = section
        ? section.charAt(0).toUpperCase() + section.slice(1)
        : "";

    const statusIcons = {
        completed:
            section === "appraisal" ? (
                <CheckCircleIcon color={"success"} />
            ) : (
                <CheckCircleOutlineOutlinedIcon color={"success"} />
            ),
        review: <ChangeCircleOutlinedIcon color={"info"} />,
        incomplete: <PendingOutlinedIcon color={"info"} />,
        escalated: <ErrorOutlinedIcon color={"error"} />,
        error: <ErrorOutlineOutlinedIcon color={"error"} />,
    };

    const icon = statusIcons[status] || (
        <RadioButtonUncheckedIcon color={"disabled"} />
    );

    return (
        <Tooltip title={title} placement="top" arrow>
            {icon}
        </Tooltip>
    );
};

export default AppraisalStatusIcon;
